import { type Components, type Theme } from "@mui/material/styles";

export const timelineOppositeContent: Components<Theme>["MuiTimelineOppositeContent"] =
  {
    styleOverrides: {
      root: ({ theme }) => ({
        paddingLeft: 0,
        // Mirror the content column so the opposite content lands on the dot's
        // centerline too (see the timelineContent override for the geometry).
        [theme.breakpoints.up("sm")]: {
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          height: 35,
          paddingBlock: 0,
        },
      }),
    },
  };
